import { FEATURE_FLAG_CONFIG } from "./feature-flags-helper.js";
import { FeatureFlagType } from "../generated/graphql.js";
const { FEATURE_FLAG_QUERY_VARIABLES: feature_flags_utils_FEATURE_FLAG_QUERY_VARIABLES, DEFAULT_CLIENT_FEATURE_FLAGS: feature_flags_utils_DEFAULT_CLIENT_FEATURE_FLAGS, serverKeyToClientKeyMap: feature_flags_utils_serverKeyToClientKeyMap } = getVariablesAndDefaultFlags();
function mapFeatureFlagResponse(response) {
    if (void 0 === response) return feature_flags_utils_DEFAULT_CLIENT_FEATURE_FLAGS;
    const { featureFlagsV2 } = response;
    const result = {
        ...feature_flags_utils_DEFAULT_CLIENT_FEATURE_FLAGS
    };
    for (const { key: serverKey, value } of featureFlagsV2){
        const clientKey = feature_flags_utils_serverKeyToClientKeyMap.get(serverKey);
        if (void 0 !== clientKey) {
            if ('boolValue' in value) {
                result[clientKey] = value.boolValue;
                continue;
            }
            if ('stringValue' in value) {
                result[clientKey] = value.stringValue;
                continue;
            }
            result[clientKey] = value.intValue;
        }
    }
    return result;
}
function getVariablesAndDefaultFlags() {
    const flags = [];
    const defaultFlags = {};
    const serverKeyToClientKeyMap = new Map();
    for(const prop in FEATURE_FLAG_CONFIG){
        const clientKey = prop;
        const { key: serverKey, value: defaultValue } = FEATURE_FLAG_CONFIG[clientKey];
        let flagType;
        switch(typeof defaultValue){
            case 'boolean':
                flagType = FeatureFlagType.BOOL;
                break;
            case 'string':
                flagType = FeatureFlagType.STRING;
                break;
            case 'number':
                flagType = FeatureFlagType.INT;
                break;
        }
        flags.push({
            key: serverKey,
            flagType
        });
        defaultFlags[clientKey] = defaultValue;
        serverKeyToClientKeyMap.set(serverKey, clientKey);
    }
    const DEFAULT_CLIENT_FEATURE_FLAGS = defaultFlags;
    const FEATURE_FLAG_QUERY_VARIABLES = {
        flags
    };
    return {
        DEFAULT_CLIENT_FEATURE_FLAGS,
        FEATURE_FLAG_QUERY_VARIABLES,
        serverKeyToClientKeyMap
    };
}
export { feature_flags_utils_DEFAULT_CLIENT_FEATURE_FLAGS as DEFAULT_CLIENT_FEATURE_FLAGS, feature_flags_utils_FEATURE_FLAG_QUERY_VARIABLES as FEATURE_FLAG_QUERY_VARIABLES, mapFeatureFlagResponse };

//# sourceMappingURL=feature-flags-utils.js.map